<div class="cards-container">
    <ng-container *ngFor="let resource of resources">
        <app-resource-card [resource]="resource"></app-resource-card>
    </ng-container>
    <ng-container *ngFor="let key of [].constructor(33)">
        <div class="hidden-card"></div>
    </ng-container>
</div>
